import { IBaseSortModel, SortDirections } from '../../interfaces/PagedSortedSearch';

import classNames from 'classnames';

function SortData<T>(props: {
    active?: boolean;
    currentSortModel?: IBaseSortModel<T>;
    fieldName: string;
    sortData: (
        fieldName: string,
        order: string,
        subKey?: string,
        subGrandKey?: string,
        dataObjectIdentifier?: number
    ) => void;
    dataObjectIdentifier?: number;
    subKey?: string;
    subGrandKey?: string;
    stackControls?: boolean;
}) {
    const handleSort = (sortDirection?: string) => {
        props.sortData(
            props.fieldName,
            sortDirection || 'asc',
            props.subKey,
            props.subGrandKey,
            props.dataObjectIdentifier
        );
    };

    const spanClass = classNames({
        'stacked-sort-controls': props.stackControls,
    });

    const sortedAscending =
        props.active && props.currentSortModel?.sortDirection === SortDirections.Asc;
        
    const sortedDescending =
        props.active && props.currentSortModel?.sortDirection === SortDirections.Desc;

    return (
        <div className={spanClass} style={props.stackControls ? {} : undefined}>
            <button className="btn-no-bg sort-arrow">
                <i
                    className={classNames('fal fa-lg fa-angle-up', {
                        'color-black': sortedDescending,
                    })}
                    onClick={() => {
                        handleSort('desc');
                    }}
                />
            </button>
            <button className="btn-no-bg sort-arrow">
                <i
                    className={classNames('fal fa-lg fa-angle-down', {
                        'color-black': sortedAscending,
                    })}
                    onClick={() => {
                        handleSort();
                    }}
                />
            </button>
        </div>
    );
}

export default SortData;
